<template>
  <div>Test</div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "atms-page",
  components: {},
})
export default class ATMsPage extends Vue {
  constructor() {
    super();
  }
}
</script>
